import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { seoData } from "@/src/seoConfig";

const PageSEO = () => {
  const { pathname } = useLocation();
  const seo = seoData[pathname as keyof typeof seoData] || seoData.default;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
    </Helmet>
  );
};

export default PageSEO;
